module.exports = __webpack_public_path__ + "assets/img/reward-1-81cb7986.png";